import { getAddressString } from "../strings";
import type { Nullable, NullableFields, Tables } from "../types";

/**
 * This function opens a new tab with Google Maps and searches for the given address.
 * It uses the `getAddressString` function to format the address into a string.
 * The address object should contain the following properties: streetName, city, zipCode, and houseNumber.
 * If the window object is not defined (e.g., in a server-side environment), it will just return the URL instead of opening a new tab.
 * @param address
 * @returns The URL to the Google Maps search for the given address.
 */
export function openGoogleMaps(
	address: Nullable<
		NullableFields<Pick<Tables<"projects">, "streetName" | "city" | "zipCode" | "houseNumber">>
	>,
	open = true,
) {
	if (!address) return;
	const addressString = getAddressString(address);
	const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressString)}`;
	if (typeof window !== "undefined" && open) {
		window.open(url);
	}
	return url;
}
